<template>
	<div class="drawer">
		<el-drawer
		size="80%"
		:visible.sync="drawerStatus"
		@close='handleClose'
		>	
			<div slot="title">
				<span></span>
				<!-- <span style="font-size: 14px;color:red;">（总金额：0元）</span> -->
			</div>
			<!-- 赠品 -->
			<div style="padding:20px;" v-if="tableData.length>0">
				<div style="padding-bottom:10px;">
					赠品
					<span style="color:red" v-if="giveGoods.give_type===1">
						( 以下商品可赠送{{giveGoods.give_count}}件 )
					</span>
				</div>
				<div style="padding:10px 20px;">
					<el-row>
						<el-col :span="5">
							<el-input v-model="scanningCodeInput" @keyup.enter.native="clickScanningCodeInput" placeholder="请输入商品条码">
								<template slot="append">
									<el-button type="danger" icon="el-icon-search" @click="clickScanningCodeInput"></el-button>
								</template>
							</el-input>
						</el-col>
					</el-row>
					<el-table :data="tableData" default-expand-all style="width: 100%;margin-bottom: 20px;" row-key="tableKey">
						<el-table-column type="expand">
							<template slot-scope="props">
								<div v-if="!$public.isNull(props.row.goodsList)">
									<el-tag style="margin: 5px;" v-for="item in props.row.goodsList" :key="item.tableKey" closable @close="del_goods(item)">
										{{item.customCode}}
									</el-tag>
								</div>
								<div v-else>无条码</div>
							</template>
						</el-table-column>
						<el-table-column prop="goodsName" label="名称" width="400">
						</el-table-column>
						<el-table-column prop="skuValue" label="规格">
						</el-table-column>
						<el-table-column prop="num" label="数量" width="300">
							<template slot-scope="props">
								<el-input v-if="(props.row.goodsType===3||props.row.goodsType===6)&&giveGoods.give_type===1" v-model="props.row.num" @input="inputNum(props.row)" style="width:100px;"></el-input>
								<span v-else>{{props.row.num}}</span>
							</template>
						</el-table-column>
					</el-table>
				</div>
			</div>
			<!-- 关联商品 -->
			<div style="padding:20px;" v-if="tableData1.length>0">
				<div style="padding-bottom:10px;">
					关联商品
					<span style="color:red" v-if="useGoods.select_way.value==='0'">
						( 以下商品需录入{{useGoods.select_num}}件 )
					</span>
				</div>
				<div style="padding:10px 20px;">
					<el-row>
						<el-col :span="5">
							<el-input v-model="scanningCodeInput1" @keyup.enter.native="clickScanningCodeInput1" placeholder="请输入商品条码">
								<template slot="append">
									<el-button type="danger" icon="el-icon-search" @click="clickScanningCodeInput1"></el-button>
								</template>
							</el-input>
						</el-col>
					</el-row>
					<el-table :data="tableData1" default-expand-all style="width: 100%;margin-bottom: 20px;" row-key="tableKey">
						<el-table-column type="expand">
							<template slot-scope="props">
								<div v-if="!$public.isNull(props.row.goodsList)">1
									<el-tag style="margin: 5px;" v-for="item in props.row.goodsList" :key="item.tableKey" closable @close="del_goods1(item)">
										{{item.customCode}}
									</el-tag>
								</div>
								<div v-else>无条码</div>
							</template>
						</el-table-column>
						<el-table-column prop="goodsName" label="名称" width="400">
						</el-table-column>
						<el-table-column prop="skuValue" label="规格">
						</el-table-column>
						<el-table-column prop="num" label="数量" width="300">
							<template slot-scope="props">
								<span>{{props.row.num}}</span>
							</template>
						</el-table-column>
					</el-table>
				</div>
			</div>
			<el-button type="success" @click="submit" style="margin:50px 0 0 30px;">完成</el-button>
		</el-drawer>
	</div>
</template>

<script>
	import del from "../../util/del.js"
	export default {
		data() {
			return {
				drawerStatus:false,
				// 商品
				scanningCodeInput:'',
				scanningCodeInput1:'',
				tableData:[],
				tableData1:[],
				o:null,
				o1:null,
			}
		},
		computed:{
			
		},
		props:{
			giveGoods:{
				default:()=>{
					return {}
				}
			},
			useGoods:{
				default:()=>{
					return {}
				}
			}
		},
		mounted(){
			this.$nextTick(()=>{
				this.drawerStatus = true;
			})
			this.o = new del();
			this.o1 = new del();
			let arr = []
			if(this.giveGoods.giftTableData&&this.giveGoods.giftTableData.length>0){
				arr = this.giveGoods.giftTableData;
			}else{
				let table = this.giveGoods.give_list;
				if(!this.$public.isNull(table)){
					for(let i=0;i<table.length;i++){
						let goods = {
							tableKey: 'tableKey'+Math.random(),
							goodsId:table[i].goods_id,
							goodsName:table[i].goods_name,
							goodsType:table[i].param_type_id,
							skus:table[i].skus,
							skuValue:table[i].sku_value,
							num:table[i].goods_count,
							unitId:table[i].packing_way_id,
							unit:table[i].packing_way_name,
							goodsList:[],
						}
						goods.checkGoods = JSON.parse(JSON.stringify(goods));
						arr.push(goods)
					}
				}
			}
			this.o.init(arr)
			this.tableData = this.o.arr;
			let arr1 = []
			if(this.giveGoods.goodsTableData&&this.giveGoods.goodsTableData.length>0){
				arr1 = this.giveGoods.goodsTableData;
			}else{
				let table1 = this.useGoods.goods_list;
				if(!this.$public.isNull(table1)){
					for(let i=0;i<table1.length;i++){
						console.log(i)
						let goods = {
							tableKey: 'tableKey'+Math.random(),
							goodsId:table1[i].goods_id,
							goodsName:table1[i].goods_name,
							goodsType:table1[i].param_type_id,
							skus:table1[i].skus,
							skuValue:table1[i].sku_value,
							num:table1[i].goods_count,
							unitId:table1[i].packing_way_id,
							unit:table1[i].packing_way_name,
							goodsList:[],
						}
						goods.checkGoods = JSON.parse(JSON.stringify(goods));
						arr1.push(goods)
					}
				}
			}
			this.o1.init(arr1)
			this.tableData1 = this.o1.arr;
		},
		methods: {
			handleClose(){
				this.$emit("submit",{giftTableData:this.tableData,goodsTableData:this.tableData1})
			},
			inputNum(row){
				row.num = this.$public.FInt(row.num);
			},
			// 商品
			clickScanningCodeInput() {
				this.getScanData(this.scanningCodeInput);
			},
			getScanData(code) {
				this.scanningCodeInput=''
				this.o.searchGoods(code).then(()=>{
					if(this.giveGoods.give_type===1){
						let addState = this.o.addTwoGoods(); // 不限量
						if(addState===true){
							console.log('添加成功')
						}
						let table = this.o.arr;
						for(let i=0;i<table.length;i++){
							if(table[i].goodsType!==3&&table[i].goodsType!==6){
								table[i].num = table[i].goodsList.length;
							}
						}
						this.tableData = table;
					}else{
						let addState = this.o.addTwoGoods(['xianliang']);
						if(addState===true){
							console.log('添加成功')
						}
						this.tableData = this.o.arr;
					}
				})
			},
			del_goods(row){
				this.$confirm('确定要删除?', '警告', {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
					type: 'warning'
				}).then(() => {
					this.o.delTwo([row.oneIndex,row.twoIndex]);
					this.tableData = this.o.arr;
				})
			},
			clickScanningCodeInput1() {
				this.getScanData1(this.scanningCodeInput1);
			},
			getScanData1(code) {
				this.scanningCodeInput1=''
				this.o1.searchGoods(code).then(()=>{
					if(this.useGoods.select_way.value==='0'){
						let addState = this.o1.addTwoGoods(); // 不限量
						if(addState===true){
							console.log('添加成功')
						}
						let table = this.o1.arr;
						for(let i=0;i<table.length;i++){
							table[i].num = table[i].goodsList.length;
						}
						this.tableData1 = table;
					}else{
						let addState = this.o1.addTwoGoods(['xianliang']);
						if(addState===true){
							console.log('添加成功')
						}
						this.tableData1 = this.o1.arr;
					}
				})
			},
			del_goods1(row){
				this.$confirm('确定要删除?', '警告', {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
					type: 'warning'
				}).then(() => {
					this.o1.delTwo([row.oneIndex,row.twoIndex]);
					this.tableData1 = this.o1.arr;
				})
			},
			submit(){
				this.$emit("submit",{giftTableData:this.tableData,goodsTableData:this.tableData1})
			}
		}
	}
</script>

<style scoped lang="scss">
	.drawer{
		width:0;
		padding:0 0 0 0;
		::v-deep.el-drawer{
			.label{
				display: inline-block;width:100px;text-align: right;
			}
			.el-drawer__body{
				height: 100%;overflow-y:auto;padding-bottom:100px;
			}
		}
		
	}
	
</style>
